/**
 * THE three-way "unsaved changes" prompt's button deck — `Keep editing` ·
 * `Discard changes` · `Save and close` — the ONE answer to *"what do the
 * buttons on a would-lose-an-edit prompt say"*. Spread `UNSAVED_PROMPT_BUTTONS`
 * into `ConfirmDialog`; never retype a label at a call site.
 *
 * Callers (count them, never trust this list): `OrderInlineEditor.js`'s
 * collapse prompt (every order page + the hires Table), `gags/GagGroupTable.js`'s
 * row prompt, and `pages/BudgetCostCodes.js`'s day-grid exit prompt (which
 * overrides `confirmLabel` to `Save and continue` and keeps the short `Save`).
 *
 * 📱 MOBILE (2026-10-01, owner): on a 360px phone the full labels wrapped the
 * row onto two lines. Below `md` (768px) `ConfirmDialog` renders the `…Mobile`
 * labels — `Keep editing` · `Discard` · `Save` — on ONE row; from `md` up the
 * full labels are unchanged. The swap is done by `ConfirmDialog` from these
 * props, so no caller carries its own breakpoint or its own short copy.
 * 🔑 Order, danger-soft Discard, green Save as the primary and `initialFocus:
 * 'cancel'` (Keep editing) are the same at every width. `variant="save"` stays
 * WRITTEN at each call site — `constants/saveButtonsAreConfirm.test.js` reads it
 * there — see `ConfirmDialog`'s
 * docblock for why each is so.
 */
export const UNSAVED_PROMPT_KEEP_EDITING = 'Keep editing';
export const UNSAVED_PROMPT_DISCARD = 'Discard changes';
export const UNSAVED_PROMPT_DISCARD_MOBILE = 'Discard';
export const UNSAVED_PROMPT_SAVE_AND_CLOSE = 'Save and close';
export const UNSAVED_PROMPT_SAVE_MOBILE = 'Save';

/**
 * The order prompt's body. It said "…before the row closes" until 2026-10-01;
 * the prompt now also fires on a tab, row or link change
 * (`hooks/useDirtyContinuation.js`), so it names the order, not the row.
 */
export const UNSAVED_ORDER_PROMPT_MESSAGE =
  'This order has edits that have not been saved. Choose what to do before you leave this order.';

export const UNSAVED_PROMPT_BUTTONS = Object.freeze({
  cancelLabel: UNSAVED_PROMPT_KEEP_EDITING,
  altLabel: UNSAVED_PROMPT_DISCARD,
  altLabelMobile: UNSAVED_PROMPT_DISCARD_MOBILE,
  confirmLabel: UNSAVED_PROMPT_SAVE_AND_CLOSE,
  confirmLabelMobile: UNSAVED_PROMPT_SAVE_MOBILE,
  initialFocus: 'cancel',
});
